
/*
Defines the custom element <ravel-progressive-composition>
*/

import { RavelProgressiveComposition } from './src/RavelProgressiveComposition.js';

customElements.define('ravel-progressive-composition', RavelProgressiveComposition);
